import { View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMBarChartCard,
  PMDonutChartCard,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { DONUT_CARD_LAYOUT } from "../../../constants";
import {
  getAllReportingItems,
  getArrayFieldData,
  withTotalInTitle,
} from "../get-dashboard-chart-data";

/**
 * Adds the "systems per capability" bar and donut chart cards, in that order
 * (#2222).
 */
export function addCapabilitiesDashboardCards(
  view: View<TestAppState, DragAndDropLayout>
) {
  const capabilitiesBarChartComponent = view.addComponent({
    component: PMBarChartCard,
    layoutProps: {
      componentId: "capabilitiesDashboardBarChartComponent",
      labels: ["barChart", "chart", "capability"],
      description: "Shows systems grouped by capability across all projects.",
      title: "Systems per Capability",
    },
  });

  capabilitiesBarChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.applicationCapabilities
    );

    return {
      title: "Systems per Capability",
      categories: entries.map((entry) => entry.label),
      data: entries.map((entry) => entry.count),
      chartType: 1 as const,
      xLabel: "Systems",
      yLabel: "Capability",
      colors: entries.map((entry) => entry.color),
      fixedHeight: "320px",
    };
  });

  const capabilitiesDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "capabilitiesDashboardDonutChartComponent",
      labels: ["donutChart", "chart", "capability"],
      description: "Shows systems grouped by capability across all projects.",
      title: "Systems per Capability",
    },
  });

  capabilitiesDonutChartComponent.mapState(({ dashboard }) => {
    const allItems = getAllReportingItems(dashboard);
    const { entries } = getArrayFieldData(
      allItems,
      (item) => item.basicItem?.applicationCapabilities
    );

    return {
      title: withTotalInTitle("Systems per Capability", allItems.length),
      icon: "DonutLarge",
      ...DONUT_CARD_LAYOUT,
      data: entries.map((entry) => ({
        label: entry.label,
        value: entry.count,
        color: entry.color,
      })),
    };
  });
}
